module.exports = __webpack_public_path__ + "df818314cb52b93a9b90092b7837c825.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/isaac.jpg
// module id = 267
// module chunks = 0